module.exports = __webpack_public_path__ + "img/Pista_1901_I.b3d69e02.png";